'use es6';

import { Record } from 'immutable';
import { BASE_FIELDS } from 'AdsUI/records/reporting/AdWordsGenericAdReportingRecord';
export default Record(Object.assign({}, BASE_FIELDS, {
  appStore: null,
  description2: null
}));